import { useController, useFormContext } from "react-hook-form"
import { t } from "i18next"
import { Input } from "@/components/ui/input"
import { CountrySelectorFormSchema } from "@/models/patient"

type Props = {
  required?: boolean
}
const HouseNumberStreet = ({ required = true }: Props) => {
  const form = useFormContext<CountrySelectorFormSchema>()
  const {
    register,
    control,
    trigger,
    formState: { errors: formErrors },
  } = form

  /*
   This has been revised according to the PR reviewer's feedback. The phrase 'streetAddress' 
   is now rendered as 'Street and house number' (and similarly in German).
  */
  const streetAddressWithNumber = `${t("common.streetAddress")}`
  const { field: houseNumberStreet } = useController({ name: "houseNumberStreet", control })

  return (
    <Input
      testId="house-number-street"
      label={`${streetAddressWithNumber}`}
      required={required}
      wrapperProps={{ className: "col-span-4" }}
      error={t(formErrors?.houseNumberStreet?.message || "")}
      {...register("houseNumberStreet")}
      onChange={(e) => {
        houseNumberStreet.onChange(e.target.value)
        trigger("houseNumberStreet")
      }}
    />
  )
}

export { HouseNumberStreet }
